export default {
  STATUS: [
    { LABEL: 'LINHAS NÃO SECCIONADAS', VALUE: 0 },
    { LABEL: 'LINHAS SECCIONADAS', VALUE: 1 },
  ],
};
